import { Injectable } from '@angular/core';
import { delay } from '../../_helpers/delay';

@Injectable({
  providedIn: 'root',
})
export class HttpSpinnerService {
  public showSpinner = false;
  private queue: number[] = [];
  private timer: any;
  private minSpinDuration = 900;
  private spinDuration = 0;

  get queueLength() {
    return this.queue.length;
  }

  public get canHide(): boolean {
    if (this.queueLength === 1) {
      return true;
    }
    return false;
  }
  public show() {
    this.showSpinner = true;
    const newIndex = this.queueLength + 1;
    this.queue.push(newIndex);
    if (newIndex === 1) {
      this.timer = setTimeout(() => {
        this.spinDuration += 100;
      }, 100);
    }
  }

  public async hide() {
    if (this.canHide) {
      if (this.spinDuration < this.minSpinDuration) {
        await delay(this.minSpinDuration - this.spinDuration);
      }
      this.showSpinner = false;
      this.spinDuration = 0;
      clearTimeout(this.timer);
    }
    this.queue.pop();
  }
}
